import { useEffect, useRef, useState } from 'react';
import { imgs } from '../assets/imgs';
import { tracking } from '../utils/tracking';
import { Banner, InfoSection, PressForm, VideoSection } from '../components';
import { useResizeImg } from '../hooks/useResizeImg';
import { updateTags } from '../utils/funcs';

const vidUrl = "https://www.youtube.com/embed/9o0uXtzun58?modestbranding=1&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=9o0uXtzun58";
const vidHeader = "Watch the trailer for the Venture Summit";

export const Press = () => {
   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.press.pressBannerDesktop, imgs.press.pressBannerMobile)
   const scrollRef = useRef(null);

  useEffect(() => {
      updateTags("Venture Summit West | Press")
  }, [])

   return (
      <div className='press'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1>Media</h1>
               <h2>Share with the Whole World the Best in Tech</h2>
            </section>
            <section>
               <button className="btn" onClick={() => { tracking(342); scrollRef.current.scrollIntoView({ behavior: 'smooth' }) }}>APPLY NOW</button>
            </section>
         </Banner>
         <InfoSection img={imgs.press.pressInfo}>
            <h1>Press and Media</h1>
            <span></span>
            <p>As the global leaders of technology assemble, so too do Journalists from the world’s most influential publications.</p>
            <p>Gain access to a massive global, influential network of companies and top innovators and assist us in showcasing these emerging companies to the world.</p>
            <p>Media accreditation will be determined based upon your credentials.</p>
            <p>Apply below and join us for the Venture Summit.</p>
         </InfoSection>
         <VideoSection url={vidUrl} header={vidHeader} />
         <div ref={scrollRef} style={{ scrollMargin: '70px' }} />
         <PressForm />
      </div>
   )
}
